export default {
  'pages.layouts.userLayout.title': '顧客至上、事業服務、合理收費',
  'pages.login.accountLogin.tab': '賬戶密碼登錄',
  'pages.login.accountLogin.errorMessage': '錯誤的用戶名或密碼',
  'pages.login.failure': '登錄失敗，請重試！',
  'pages.login.success': '登錄成功！',
  'pages.login.username.placeholder': '用戶名',
  'pages.login.username.required': '用戶名是必填項！',
  'pages.login.password.placeholder': '密碼',
  'pages.login.password.required': '密碼是必填項！',
  'pages.login.phoneLogin.tab': '手機號登錄',
  'pages.login.phoneLogin.errorMessage': '驗證碼錯誤',
  'pages.login.phoneNumber.placeholder': '請輸入手機號！',
  'pages.login.phoneNumber.required': '手機號是必填項！',
  'pages.login.phoneNumber.invalid': '不合法的手機號！',
  'pages.login.captcha.placeholder': '請輸入驗證碼！',
  'pages.login.captcha.required': '驗證碼是必填項！',
  'pages.login.phoneLogin.getVerificationCode': '獲取驗證碼',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.login.rememberMe': '自動登錄',
  'pages.login.forgotPassword': '忘記密碼 ?',
  'pages.login.submit': '登錄',
  'pages.login.loginWith': '其他登錄方式 :',
  'pages.login.registerAccount': '註冊賬戶',
  'pages.welcome.link': '歡迎使用',
  'pages.welcome.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '已啟用',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',

  'pages.userTable.nickname': '昵稱',
  'pages.userTable.username': '用戶名',
  'pages.userTable.remarks': '備註',
  'pages.userTable.status': '是否啟用',
  'pages.userTable.updatedAt': '更新時間',
  'pages.userTable.updater': '更新人',
  'pages.userTable.action': '操作',
  'pages.userTable.password': '密碼',
  'pages.userTable.roles': '權限角色',
  'pages.userTable.createUser': '創建賬號',

  'pages.userTable.create.username': '用戶名稱不能為空',
  'pages.userTable.create.password': '請輸入最少六位數的密碼',
  'pages.userTable.resetPassword': '重設密碼',
  'pages.userTable.isResetPassword': '你確定要重設密碼嗎？',
  'pages.userTable.isResetPasswordDescription':
    '請確認是否要重設密碼，重設後的密碼將為「123456」。',
  'pages.userTable.updateUser': '更新帳號資料',

  'pages.setting.password': '更改密碼',
  'pages.setting.reset.password.required': '請輸入最少六位數的密碼',
  'pages.setting.password.confirm': '請確認密碼',
  'pages.setting.password.confirm.placeholder': '請再次輸入密碼',
  'pages.setting.password.two': '請確認兩次輸入的密碼一致',

  'pages.roleTable.name': '角色名稱',
  'pages.roleTable.description': '角色說明',
  'pages.roleTable.updatedAt': '更新時間',
  'pages.roleTable.createRole': '新增角色',
  'pages.roleTable.create.name': '角色名稱不能為空',
  'pages.roleTable.permission': '角色權限',
  'pages.roleTable.update.title': '更新角色',

  'pages.districtTable.images': '屋苑圖片',
  'pages.districtTable.name': '屋苑名稱',
  'pages.districtTable.address': '屋苑所在地',
  'pages.districtTable.description': '屋苑介紹',
  'pages.districtTable.facilities': '環境設施',
  'pages.districtTable.livingTransport': '生活交通',
  'pages.districtTable.school': '學校網絡',
  'pages.districtTable.securityManagement': '治安管理',
  'pages.districtTable.isShow': '是否在官網上顯示屋苑介紹',
  'pages.districtTable.title': '屋苑管理',
  'pages.districtTable.create.district': '新增屋苑',
  'pages.districtTable.address.placeholder': '按右邊按鈕，選擇屋苑所在地',
  'pages.districtTable.create.address.required': '請選擇屋苑所在地',
  'pages.districtTable.create.name': '請填寫屋苑所在地',
  'pages.districtTable.nameStatus.show': '顯示',
  'pages.districtTable.nameStatus.noShow': '不顯示',
  'pages.districtTable.update.district':"更新屋苑",

  'pages.houseTable.update.house':"更新盘口",
  'pages.houseTable.images': '盤口圖片',
  'pages.houseTable.name': '盤口名稱',
  'pages.houseTable.address': '盤口位置',
  'pages.houseTable.description': '盤口介紹',
  'pages.houseTable.type': '盤口類型',
  'pages.houseTable.nameStatus.gy': '公寓',
  'pages.houseTable.nameStatus.hz': '豪宅',
  'pages.houseTable.nameStatus.jw': '居屋',
  'pages.houseTable.nameStatus.cw': '村屋',
  'pages.houseTable.nameStatus.dw': '丁屋',
  'pages.houseTable.nameStatus.fw': '服務式公寓',
  'pages.houseTable.nameStatus.tl': '唐樓',
  'pages.houseTable.peddleType': '租售類型',
  'pages.houseTable.nameStatus.sell': '出售',
  'pages.houseTable.nameStatus.hire': '出租',
  'pages.houseTable.status': '狀態',
  'pages.houseTable.nameStatus.shelves': '上架中',
  'pages.houseTable.nameStatus.done': '已租/售出',
  'pages.houseTable.nameStatus.staging': '暫存',
  'pages.houseTable.prices': '價格（港幣）',
  'pages.houseTable.roomsNumber': '房間數量',
  'pages.houseTable.toiletsNumber': '廳數量',
  'pages.houseTable.size': '實用面積（平方英呎）',

  'pages.houseTable.areaSize': '建築面積(平方英呎)',
  'pages.houseTable.create.areaSize': '請填寫盤口建築面積',

  'pages.houseTable.isRecommend': '是否在首頁推薦',
  'pages.houseTable.nameStatus.no': '否',
  'pages.houseTable.nameStatus.yes': '是',
  'pages.houseTable.shelveTime': '盤口上架時間',
  'pages.houseTable.completeContractTime': '盤口完成交易時間',
  'pages.houseTable.title': '盤口管理',
  'pages.houseTable.dealPrice': '成交價（僅在售出狀態顯示）',
  'pages.houseTable.dealTime': '成交时间',

  'pages.houseTable.district': '所屬屋苑',
  'pages.houseTable.create.house': '新增盤口',
  'pages.houseTable.create.peddleType': '請選擇租售類型',
  'pages.houseTable.create.address.required': '請選擇盤口位置',
  'pages.houseTable.create.name': '盤口名稱不能為空',
  'pages.houseTable.create.type': '請選擇盤口類型',
  'pages.houseTable.create.status': '請選擇盤口狀態',
  'pages.houseTable.create.prices': '請填寫租售價格',
  'pages.houseTable.create.roomsNumber': '請填寫房間數量',
  'pages.houseTable.create.toiletsNumber': '請填寫廳數量',
  'pages.houseTable.create.size': '請填寫盤口實用面積',
  'pages.houseTable.description.color': '盤口介紹顯示的顏色',
  'pages.houseTable.address.placeholder': '請選擇位置',

  'pages.feedbackTable.name': '客戶姓名',
  'pages.feedbackTable.phoneNumber': '手機號碼',
  'pages.feedbackTable.email': '電子郵件',
  'pages.feedbackTable.description': '客戶需求',
  'pages.feedbackTable.status': '是否已處理',
  'pages.feedbackTable.nameStatus.yes': '已處理',
  'pages.feedbackTable.nameStatus.no': '未處理',
  'pages.feedbackTable.title': '留言管理',
  "pages.feedbackTable.remark": "处理备注",
  "pages.feedbackTable.createdAt": "提交時間",
  "pages.feedbackTable.action": "處理",
  'pages.feedbackTable.update.title':'處理留言',

  'pages.global.delete': '刪除',
  'pages.global.remarks': '備註',
  'pages.global.nameStatus.show': '顯示',
  'pages.global.nameStatus.noShow': '不顯示',
  'pages.global.updatedAt': '更新時間',
  'pages.global.updater': '更新人',
  'pages.global.update': '更新',
  'pages.global.isDelete': '是否確認刪除',
  'pages.global.isDeleteDescription': '是否確定刪除資料？刪除後將無法恢復。',
  'pages.global.selectLocation': '選擇位置',
  'pages.global.location.required': '請點擊地圖選擇位置',
  'pages.global.select.clickMap': '點擊地圖選擇位置',
  'pages.global.select': '選擇',
};
